import { get, post, put } from "api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;
const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

const getPartnerRelationTypes = () => get(`${url}/partnerrelationtypes`);

const savePartnerRelation = (partnerRelationId, documentId, siteId, item) =>
  post(`${url}/savepartnerrelation`, {
    item: item,
    partnerRelationId: partnerRelationId,
    documentId: documentId,
    siteId: siteId
  });

const externalSearchForPartner = registrationCode =>
  put(`${url}/leasingoffers/asset/partner-from-query/registration-code`, { registrationCode });

const getClient = uniqueId => get(`${masterPartnerUrl}/Partners/${uniqueId}/lite`);

const exp = {
  getPartnerRelationTypes,
  savePartnerRelation,
  externalSearchForPartner,
  getClient
};
export default exp;
